import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';

import { AbstractControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { take } from 'rxjs';
import { ReferentielsService } from 'src/app/core/services/referentiels.service';
import { DateTime } from 'luxon';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';

@Component({
    selector: 'app-caracteristiques-generales-form',
    imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatStepperModule,
    MatAutocompleteModule
],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './caracteristiques-generales-form.component.html',
    styleUrls: ['./caracteristiques-generales-form.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class CaracteristiquesGeneralesFormComponent implements OnInit, AfterViewInit, OnChanges {
  // Make Validators available in template
  public ValidatorsRef = Validators;
  @Output() formSubmit = new EventEmitter<FormGroup>();
  @Input() qualificationForm: FormGroup;
  @Input() set agentsList(value: any[]) {
    this.filteredAgentList = value;
    this._agentsList = value;
  }
  @Input() detenteurPosteReadOnly: boolean;
  @Input() typeRecrutement: any = null; // Current recruitment type
  @Input() selectedPosteDetails: any = null; // Selected post details
  @Input() isVacataireType: boolean = false; // Whether current type is vacataire
  get agentsList(): any[] {
    return this._agentsList;
  }
  private _agentsList: any[] = [];
  filteredAgentList: any = [];
  val_ft_categorie_poste: any = null;
  val_ft_occupation_poste: any = null;
  val_ft_motif_liberation: any = null;
  val_ft_detenteur_poste: any = null;
  listDirection: any = [];
  directionList: any[] = [];
  listService: any = [];
  posteList: any[] = [];
  serviceFonctionnelList: any[] = [];
  categoriePosteList: any[] = [];

  currentYear: number = new Date().getFullYear();
  minDateRecrutement: Date;
  minDateDepart: Date;

  // filteredMotifs: Observable<string[]>;
  constructor(private readonly referentielsService: ReferentielsService) {}

  ngOnInit() {
    this.minDateRecrutement = new Date();
    
    // Initialize field states based on current inputs
    this.updateFieldStatesBasedOnWorkflow();
    this.qualificationForm.get('dateRecrutement')?.valueChanges.subscribe((value) => {
      if (typeof value === 'string' && value.length === 10) {
        const dateValue = DateTime.fromFormat(value, 'DD/MM/YYYY');
        if (dateValue.isValid) {
          this.qualificationForm.get('dateRecrutement')?.setValue(dateValue.toJSDate(), { emitEvent: false });
          this.qualificationForm.get('dateRecrutement')?.setErrors(null);
        } else {
          this.qualificationForm.get('dateRecrutement')?.setErrors({ invalidDate: true });
        }
      }
    });

    this.minDateDepart = new Date();
    this.qualificationForm.get('dateDepart')?.valueChanges.subscribe((value) => {
      if (typeof value === 'string' && value.length === 10) {
        const dateValue = DateTime.fromFormat(value, 'DD/MM/YYYY');
        if (dateValue.isValid) {
          this.qualificationForm.get('dateDepart')?.setValue(dateValue.toJSDate(), { emitEvent: false });
          this.qualificationForm.get('dateDepart')?.setErrors(null);
        } else {
          this.qualificationForm.get('dateDepart')?.setErrors({ invalidDate: true });
        }
      }
    });
    this.loadListCategoriePoste();

    this.loadListPoste();
  }

  ngAfterViewInit() {
    // initialise les vérification de champs après la création des champs
    // this.qualificationForm.controls['dateDepart'].addValidators([this.verifDateSaisie()]);
    // this.qualificationForm.controls['dateRecrutement'].addValidators([this.verifDateSaisie()]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // React to changes in recruitment type or post selection
    if (changes['typeRecrutement'] || changes['selectedPosteDetails'] || changes['isVacataireType']) {
      this.updateFieldStatesBasedOnWorkflow();
    }
  }

  verifDateSaisie = () => {
    return (control: AbstractControl): null | ValidationErrors => {
      let c_date_debut = this.qualificationForm.controls['dateDepart'].value;
      let c_date_fin = this.qualificationForm.controls['dateRecrutement'].value;

      if (!c_date_debut || !c_date_fin) {
        return null;
      }

      let dateDebut = DateTime.fromJSDate(new Date(c_date_debut)).startOf('day');
      let dateFin = DateTime.fromJSDate(new Date(c_date_fin)).startOf('day');

      if (dateDebut <= dateFin) {
        return { erreurDateDebutValid: control.value, erreurDateValidation: true };
      }
      return null;
    };
  };

  onChangeRecrutementdate() {
    const dateDepart = this.qualificationForm.get('dateDepart')?.value;
    const dateRecrutement = this.qualificationForm.get('dateRecrutement')?.value;

    this.qualificationForm.get('dateRecrutement')?.updateValueAndValidity();

    if (dateDepart) {
      if (new Date(dateRecrutement) > new Date(dateDepart)) {
        this.qualificationForm.get('dateRecrutement')?.setErrors({ dateInvalide: true });
      } else if (new Date(dateRecrutement) < new Date(Date.now() - 24 * (60 * 60 * 1000))) {
        this.qualificationForm.get('dateRecrutement')?.setErrors({ dateJourRecrutement: true });
      } else {
        this.qualificationForm.get('dateRecrutement')?.setErrors(null);
      }
    }
  }

  onDepartdate() {
    const dateDepart = this.qualificationForm.get('dateDepart')?.value;
    const dateRecrutement = this.qualificationForm.get('dateRecrutement')?.value;

    this.qualificationForm.get('dateDepart')?.updateValueAndValidity();

    if (dateRecrutement) {
      if (new Date(dateRecrutement) > new Date(dateDepart)) {
        this.qualificationForm.get('dateDepart')?.setErrors({ dateInvalide: true });
      } else if (new Date(dateDepart) < new Date(Date.now() - 24 * (60 * 60 * 1000))) {
        this.qualificationForm.get('dateDepart')?.setErrors({ dateDepartJour: true });
      } else {
        this.qualificationForm.get('dateDepart')?.setErrors(null);
      }
    }
  }

  loadListCategoriePoste() {
    this.referentielsService
      .getCategoriePoste()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.categoriePosteList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }
  loadListPoste() {
    this.referentielsService
      .getAllPostesOpened()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.posteList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }

  effaceFilteCategoriePoste(event: any, controlName: string) {
    event.stopPropagation();
    if (controlName != undefined && controlName != '') {
      this.qualificationForm.controls[controlName].setValue('');
      this.loadListCategoriePoste();
    }
  }

  effaceFilteOccupationPoste(event: any, controlName: string) {
    event.stopPropagation();
    if (controlName != undefined && controlName != '') {
      this.val_ft_occupation_poste.controls[controlName].setValue('');
    }
  }
  onSubmit() {
    if (this.qualificationForm.valid) {
      this.formSubmit.emit(this.qualificationForm);
    }
  }
  agentFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredAgentList = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.filteredAgentList = this.agentsList.filter((agent: any) =>
      (agent.nom + agent.prenom).toLowerCase().split(' ').join('').includes(filterValue)
    );
  }

  effaceField(event: any, controlName: string): void {
    event.preventDefault();
    this.qualificationForm.get(controlName)?.setValue('');
    this.filteredAgentList = [...this.agentsList];
  }

  agentdisplayFn(agent: any): string {
    return agent ? `${agent.nom} ${agent.prenom}` : '';
  }

  onReset() {
    this.qualificationForm.reset();
  }
  compareCategories(c1: any, c2: any): boolean {
    if (!c1 || !c2) return false;
    return c1.id === c2.id;
  }

  // Update field states based on workflow business rules
  private updateFieldStatesBasedOnWorkflow(): void {
    if (!this.qualificationForm) return;

    const isVacataire = this.isVacataireType;
    const hasPostSelected = !!this.selectedPosteDetails;

    const vacataireLockedFields = ['etatPoste', 'occupationPoste', 'categoriePoste'];
    const apiControlledFields = ['occupationPoste', 'categoriePoste', 'posteBudgete'];

    if (isVacataire) {
      // Vacataire recruitment: the locked fields must remain disabled and cleared regardless of post selection
      this.resetAndDisableWorkflowFields(vacataireLockedFields);

      // Poste budgeté follows existing workflow rules
      if (hasPostSelected) {
        this.disableWorkflowFields(['posteBudgete']);
      } else {
        this.enableWorkflowFields(['posteBudgete']);
      }

      return;
    }

    // Standard recruitment: re-enable locked fields if no post details are available
    this.enableWorkflowFields(['etatPoste']);

    if (hasPostSelected) {
      this.disableWorkflowFields(apiControlledFields);
    } else {
      this.enableWorkflowFields(apiControlledFields);
    }

    // Note: detenteurPoste state is managed by parent component based on holder availability
    // dateRecrutement, dateDepart, interne, externe are always user-input fields
  }

  private disableWorkflowFields(fieldNames: string[]): void {
    fieldNames.forEach((fieldName) => {
      const control = this.qualificationForm.get(fieldName);
      if (control) {
        control.disable({ emitEvent: false });
      }
    });
  }

  private enableWorkflowFields(fieldNames: string[]): void {
    fieldNames.forEach((fieldName) => {
      const control = this.qualificationForm.get(fieldName);
      if (control) {
        control.enable({ emitEvent: false });
      }
    });
  }

  private resetAndDisableWorkflowFields(fieldNames: string[]): void {
    fieldNames.forEach((fieldName) => {
      const control = this.qualificationForm.get(fieldName);
      if (control) {
        control.clearValidators();
        control.reset(null, { emitEvent: false });
        control.disable({ emitEvent: false });
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }
}
